import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'

export default function DashboardBlock({ classname, title, titlecolor, count, countcolor, amount_color, font_size, total, showbutton, link, btnname, amount, showamount, percentcolor, showpercent, loader, showModal, modalBtn,paddingTop}) {

    let percent = 0;
    if(total>0)
    percent=((count / total) * 100).toFixed(2);
    return (
        <div className={classname} style={{paddingTop:paddingTop}}>
              <Loader className="loader"
                    type="ThreeDots"
                    color="#9c1d26"
                    height={100}
                    width={100}
                    visible={loader}
                />
            <p className="title" style={{color:titlecolor}}><b>{title}</b></p>
            <p className="count" style={{color:countcolor,fontSize:font_size}} >{count}</p>
            {showpercent ? <p className="percent" style={{ color: percentcolor }}>  {percent} % of total</p> : <>{!showbutton && <>&nbsp;<br/></>}</>}
            {showamount ?<p className="amount" style={{ color: amount_color }}> &#8377;{amount} </p> : <div style={{height:16}}></div>}
            {showbutton && <Link className="viewdetailbtn" to={link} >{btnname}</Link>}
            {modalBtn && <button className="viewdetailbtn" onClick={() => showModal(true)}>{btnname}</button> }
           
        </div>
    )
}

DashboardBlock.propTypes={
    title:PropTypes.string.isRequired,
    // count:PropTypes.number.isRequired,
    // total:PropTypes.number.isRequired
}
DashboardBlock.defaultProps={
    countcolor:'white',
    showbutton:false,
    showpercent: true,
    showamount: true,
    titlecolor:"#FFFFFF",
    font_size:'50px',
    percentcolor:"#FFFFFF",
    amount_color:"#FFFFFF",
    modalBtn:false,
    paddingTop:'40px'
}